<div class="container-fluid scroll">
    <div class="row">
      <ngx-charts-number-card
        [results]="_aKpisData"
        [textColor]="textColorNumberCard"
        [animations]="false"
        [valueFormatting]="format">
      </ngx-charts-number-card>
    </div>
  </div>
